var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("general")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _c(
                          "div",
                          {
                            style: {
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                            },
                          },
                          [
                            _c("app-sale-type-select", {
                              style: { width: "250px" },
                              attrs: {
                                "contact-group-id": 1,
                                "use-id": "",
                                label: _vm.$ct("shown-sale-types"),
                                fancy: "",
                              },
                              model: {
                                value: _vm.TypeID,
                                callback: function ($$v) {
                                  _vm.TypeID = $$v
                                },
                                expression: "TypeID",
                              },
                            }),
                            _c(
                              "w-button",
                              {
                                staticClass: "ml",
                                on: {
                                  click: function ($event) {
                                    return _vm.addType()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("client-portal-settings.add-type")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "w-sortable",
                        {
                          style: { width: "100%" },
                          attrs: {
                            tag: "w-list",
                            items: _vm.config.ClientPortalTabConfigs,
                            "target-class": "handle",
                          },
                        },
                        _vm._l(
                          _vm.config.ClientPortalTabConfigs,
                          function (tab, i) {
                            return _c(
                              "w-list-item",
                              { key: tab.ID, attrs: { "show-handle": "" } },
                              [
                                _c("w-list-item-text", [
                                  _vm._v(
                                    _vm._s(
                                      tab.Name.getTranslation(_vm.$i18n.locale)
                                    )
                                  ),
                                ]),
                                !tab.Deletable
                                  ? _c(
                                      "w-list-item-action",
                                      [
                                        _c(
                                          "w-button",
                                          {
                                            attrs: { light: "" },
                                            on: {
                                              click: function ($event) {
                                                tab.Visible = !tab.Visible
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: {
                                                icon: tab.Visible
                                                  ? "eye"
                                                  : "eye-slash",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                tab.Deletable
                                  ? _c(
                                      "w-list-item-action",
                                      [
                                        _c(
                                          "w-button",
                                          {
                                            staticClass: "danger",
                                            attrs: { light: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteTab(i)
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: { icon: "trash" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        staticClass: "mls",
                                        attrs: { light: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editTab(i)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "cog" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("settings")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("portal-filter-bookyear") },
                            model: {
                              value: _vm.config.ShowActiveBookYear,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "ShowActiveBookYear", $$v)
                              },
                              expression: "config.ShowActiveBookYear",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-textarea-autogrow", {
                            attrs: {
                              label: _vm.$ct("portal-header-info"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.HeaderInfo,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "HeaderInfo", $$v)
                              },
                              expression: "config.HeaderInfo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: !_vm.config.HideToPayAmount,
                              label: _vm.$ct("show-to-pay-amount"),
                            },
                            on: {
                              input: function ($event) {
                                _vm.config.HideToPayAmount = !$event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.showEditModal,
            callback: function ($$v) {
              _vm.showEditModal = $$v
            },
            expression: "showEditModal",
          },
        },
        [
          _vm.toEditClientPortalTabConfig !== null
            ? _c(
                "w-card",
                { attrs: { "max-width": "450" } },
                [
                  _c("w-card-title", [_vm._v("Test")]),
                  _c(
                    "w-card-content",
                    [
                      _c("app-translation-input", {
                        attrs: { "use-textarea": false, "force-input": true },
                        model: {
                          value: _vm.toEditClientPortalTabConfig.Name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.toEditClientPortalTabConfig,
                              "Name",
                              $$v
                            )
                          },
                          expression: "toEditClientPortalTabConfig.Name",
                        },
                      }),
                      _vm.toEditClientPortalTabConfig.Deletable
                        ? _c("w-checkbox", {
                            staticClass: "mls mts",
                            attrs: {
                              label: _vm.$ct(
                                "client-portal-settings.ShowToSignInSeperateWindow"
                              ),
                            },
                            model: {
                              value:
                                _vm.toEditClientPortalTabConfig
                                  .ShowToSignInSeperateWindow,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditClientPortalTabConfig,
                                  "ShowToSignInSeperateWindow",
                                  $$v
                                )
                              },
                              expression:
                                "toEditClientPortalTabConfig.ShowToSignInSeperateWindow",
                            },
                          })
                        : _vm._e(),
                      _vm.toEditClientPortalTabConfig.ShowToSignInSeperateWindow
                        ? _c("app-translation-input", {
                            attrs: {
                              "use-textarea": false,
                              "force-input": true,
                            },
                            model: {
                              value:
                                _vm.toEditClientPortalTabConfig
                                  .SeperateWindowTitle,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditClientPortalTabConfig,
                                  "SeperateWindowTitle",
                                  $$v
                                )
                              },
                              expression:
                                "toEditClientPortalTabConfig.SeperateWindowTitle",
                            },
                          })
                        : _vm._e(),
                      _vm.toEditClientPortalTabConfig.ID != "overview"
                        ? _c("w-checkbox", {
                            staticClass: "mls mts",
                            attrs: {
                              label: _vm.$ct(
                                "client-portal-settings.ShowInOverview"
                              ),
                            },
                            model: {
                              value:
                                _vm.toEditClientPortalTabConfig.ShowInOverview,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditClientPortalTabConfig,
                                  "ShowInOverview",
                                  $$v
                                )
                              },
                              expression:
                                "toEditClientPortalTabConfig.ShowInOverview",
                            },
                          })
                        : _vm._e(),
                      _c("w-textarea-autogrow", {
                        staticClass: "mls mt",
                        attrs: {
                          label: _vm.$ct("client-portal-settings.Info"),
                        },
                        model: {
                          value: _vm.toEditClientPortalTabConfig.Info,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.toEditClientPortalTabConfig,
                              "Info",
                              $$v
                            )
                          },
                          expression: "toEditClientPortalTabConfig.Info",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          on: {
                            click: function ($event) {
                              _vm.toEditClientPortalTabConfig = null
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.save(),
                                (_vm.toEditClientPortalTabConfig = null)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }